import { Select, Space } from "antd"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import React, { useEffect, useState } from "react"
import { db } from "../../firebase/config"
import moment from "moment"

const { Option } = Select

export default function Product({
  value,
  setValue,
  client,
  setNewPriceWithParameters,
  productsFor,
  setProductsFor,
}) {
  //manufacturers data form db
  const [allProducts, setAllProducts] = useState()
  const [productsLoading, setProductsLoading] = useState(true)
  const [disable, setDisable] = useState(true)

  const productsForOptions = [
    {
      label: "Label",
      value: "priceCalculation",
    },
    {
      label: "Tape",
      value: "tapePrices",
    },
    {
      label: "Blanks",
      value: "blanks",
    },
  ]

  //handles products for select
  const handleProductsFor = (value, option) => {
    setProductsFor(value)
  }

  //function that filters, and checks the timestamp
  // if there are duplicateds, picks the latest one.
  const filterAndLatest = (data) => {
    return data.reduce((acc, current) => {
      const existingProduct = acc.find((p) => p.product.productName === current.product.productName)
      if (existingProduct) {
        const existingTimestamp = moment.unix(existingProduct.timestamp.seconds)
        const currentTimestamp = moment.unix(current.timestamp.seconds)
        if (existingTimestamp.isBefore(currentTimestamp)) {
          acc.splice(acc.indexOf(existingProduct), 1, current)
        }
      } else {
        acc.push(current)
      }
      return acc
    }, [])
  }

  //sets the data of the manufacturers
  useEffect(() => {
    setProductsLoading(true)
    if (client) {
      let ref
      let q
      if (productsFor === "blanks") {
        ref = collection(db, "priceCalculation")
        q = query(
          ref,
          where("clientId", "==", client.id),
          where("aproved", "==", true),
          where("machine", "==", "Cutter")
        )
      } else {
        ref = collection(db, productsFor)
        q = query(
          ref,
          where("clientId", "==", client.id),
          where("aproved", "==", true),
          where("hasTechincalPage", "==", 2)
        )
      }

      const unsubscribe = onSnapshot(q, (snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ ...doc.data(), id: doc.id })
        })

        //sets the product with filter
        setAllProducts(filterAndLatest(results))
        setProductsLoading(false)
        setDisable(false)
      })
      return () => unsubscribe()
    } else {
      setProductsLoading(false)
    }
  }, [client, productsFor])

  //updates state
  const handleChange = (value, option) => {
    setValue(option.option)
    setNewPriceWithParameters({
      cenaPar1000uzlimemEur: 0,
      totalCount: 0,
    })
  }

  return (
    <>
      <Space.Compact block>
        <Select
          onChange={handleProductsFor}
          value={productsFor}
          options={productsForOptions}
          style={{ width: "20%" }}
        />
        <Select
          showSearch
          disabled={disable}
          loading={productsLoading}
          onChange={handleChange}
          value={value && value.product.productName}
          style={{ width: "80%" }}
          placeholder="Select client"
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.option.product.productName ?? "").toLowerCase().includes(input.toLowerCase())
          }>
          {allProducts &&
            allProducts.map((product) => (
              <Option key={product.id} option={product} value={product.product.productName}>
                {product.product.productName}
              </Option>
            ))}
        </Select>
      </Space.Compact>
    </>
  )
}
